import React, { useEffect } from "react";
import { dateCalculations } from "../../utils/date-converter";
import { GET_AUTHED_CLIENT_QUERY } from "../../graphql/queries/clients";
import { useQuery } from "@apollo/client";
import { METER_TELEMETRY_STATES } from "../../utils/meter-telemetry-states";
import Loader from "../../components/loader/loader";

const MyPower = () => {
  const { data, loading, error, startPolling, stopPolling } = useQuery(
    GET_AUTHED_CLIENT_QUERY,
    {
      fetchPolicy: "network-only",
    }
  );

  useEffect(() => {
    startPolling(3000);

    return () => {
      stopPolling();
    };
  }, [startPolling, stopPolling]);

  // A client with no telemetry yet has an empty set.
  const state = data?.authenticatedClient?.latestmetertelemetrySet?.[0]?.state;
  const expiryDate = data?.authenticatedClient?.expiryDate;

  if (loading) {
    return <Loader sizeClass={"size--medium"} />;
  }

  if (error) {
    return <div className="display-page__error">Something went wrong</div>;
  }

  return (
    <div className="display-page">
      <div className="display-page__title">My Power</div>
      <div className="display-page__power-wrapper">
        <div className="display-page__icons-wrapper">
          {["A_0", "_3", "_1"].includes(state) && (
            <div className="display-page__col">
              <img
                className="display-page__icon"
                src="/images/expired.png"
                alt="power-off"
              />

              <div className="display-page__icon-title">
                {METER_TELEMETRY_STATES[state]}
              </div>
            </div>
          )}

          {["A_1", "A_2"].includes(state) && (
            <div className="display-page__col">
              <img
                className="display-page__icon"
                src="/images/power-on.png"
                alt="power-on"
              />

              <div className="display-page__icon-title">
                {METER_TELEMETRY_STATES[state]}
              </div>
            </div>
          )}

          {["_2"].includes(state) && (
            <div className="display-page__col">
              <img
                className="display-page__icon"
                src="/images/exclamation-mark.svg"
                alt="daily-cap"
              />

              <div className="display-page__icon-title">
                {METER_TELEMETRY_STATES[state]}
              </div>
            </div>
          )}
        </div>

        <div className="display-page__expiry-details">
          <div className="display-page__text display-page__text--small">
            Your credit{" "}
            {dateCalculations(expiryDate).days_until < 1
              ? "expired"
              : "will expire in"}
          </div>
          <div className="display-page__text display-page__text--bold">
            {`${Math.abs(dateCalculations(expiryDate).days_until)} Day(s)`}
          </div>
          <div className="display-page__text display-page__text--bold">
            {`(${dateCalculations(expiryDate).day}, ${
              dateCalculations(expiryDate).month
            })`}{" "}
            {dateCalculations(expiryDate).days_until < 1 && "ago"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyPower;
